import {IDriveThruTransaction} from "./api/driveThruReplayModels";
import {TransactionItem} from "@/features/ticket";

// Returns a transaction's purchased line items from its ticket, excluding zero-quantity
// combo components and unnamed rows so previews and counts reflect what was actually ordered.
export function getPurchasedItems(
    transaction: IDriveThruTransaction | null | undefined
): TransactionItem[] {
    return (
        transaction?.ticket?.transactionItems.filter(
            (item) => (item.quantity ?? 0) > 0 && !!item.description?.trim()
        ) ?? []
    );
}

// Returns the primary payment description for a transaction from its ticket, or null.
export function getPaymentDescription(
    transaction: IDriveThruTransaction | null | undefined
): string | null {
    return transaction?.ticket?.paymentMethods?.[0]?.paymentDescription ?? null;
}

// Builds a short item summary like "Burger +3 more" using the most expensive item; returns "" when there are no items.
export function getOrderPreview(
    transaction: IDriveThruTransaction | null | undefined
): string {
    const items = getPurchasedItems(transaction);
    if (items.length === 0) return "";
    const mostExpensive = items.reduce((max, item) =>
        (item.price ?? 0) > (max.price ?? 0) ? item : max
    );
    const name =
        (mostExpensive.quantity ?? 0) > 1
            ? `${mostExpensive.description} x${mostExpensive.quantity}`
            : mostExpensive.description;
    const remaining = items.length - 1;
    return remaining > 0 ? `${name} +${remaining} more` : name;
}
